<template>
  <div class="animated fadeIn">
    <h1>Överför kunder</h1>

    <p>Hämta kunder från Fortnox.</p>
    <b-row>
      <b-col>
        <b-button @click="GetCustomers()">
          <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
          Hämta kunder från Fortnox
        </b-button>
        &nbsp;
        <b-button @click="UpdateParties()">
          <span class="glyphicon glyphicon-upload" aria-hidden="true"></span>
          Uppdatera Transplanet
        </b-button>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-button size="sm" @click="MarkAll(true)">Markera alla</b-button>
      &nbsp;
      <b-button size="sm" @click="MarkAll(false)">Avmarkera alla</b-button>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b>Totalt antal: {{ parties.length }}</b>
      </b-col>
      <b-col>
        <b>Antal markerade: {{ GetMarked().length }} </b>
      </b-col>
    </b-row>
    <b-row>
      <b-col>

      
    <b-card cols="5" v-if="parties.length>0">
      <b-row>        
        <b-col cols="1"><b>Kundnr</b></b-col>
        <b-col cols="4"><b>Namn</b></b-col>
        <b-col cols="4"></b-col>
      </b-row>
      <b-row v-for="(p, i) in parties" :key="i">
        <b-col cols="1"><b-icon-check-circle-fill
            v-if="p.marked"
            @click="ToggleSelected(p)"
          />
          <b-icon-circle v-if="!p.marked" @click="ToggleSelected(p)" />
          {{ p.InternalId }}</b-col>
        <b-col cols="4">{{ p.Name }}</b-col>
        <b-col cols="4">{{ p.res }}</b-col>
      </b-row>
    </b-card>
    </b-col>
    </b-row>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "partytransfer",
  data() {
    return {
      parties: [],
      updateList: [],
      logRefresherMs: 0,
    };
  },
  methods: {
    GetCustomers() {
      //alert("Get customers");
      api.get("/api/apieconomy/GetEconomyAllParties").then((res) => {
        this.parties = res.data.parties;
      });
    },
    MarkAll(v) {
      this.parties.map(function (x) {
        x.marked = v;
      });
      this.$forceUpdate();
    },
    GetMarked() {
      //return this.parties;
      return this.parties.filter(function (x) {
        return x.marked;
      });
    },
    ToggleSelected(r) {
      r.marked = !r.marked;
      this.$forceUpdate();
    },
    UpdateParties() {
      this.updateList = this.GetMarked();
      if (this.updateList.length == 0) {
        alert("Finns inga markerade företag att överföra.");
        return;
      }
      this.updateOneParty();
    },
    updateOneParty() {
      console.log("updateOneParty:" + this.updateList.length);

      this.logRefresherMs = 400;

      if (this.updateList.length > 0) {
        var p = this.updateList[0];
        api.post("/api/apieconomy/UpdatePartyInTp", p).then((res) => {
          p.res = res.data;
          this.updateList.shift();

          setTimeout(this.updateOneParty(), 1000);
          this.$forceUpdate();
        });
      } else {
        console.log("updateList is empty");

        //$scope.AddToLog("Överföring klar.");
        //$scope.UpdateLog();
      }
    },
  },
};
</script>